import { useEffect, useMemo, useState } from 'react'
import RoutesMap from 'route_control/RouteControl'
import { Container } from 'react-bootstrap'
import * as Icons from 'lucide-react'
import { User } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { sidebar } from '../../../redux/slices/assets'
import { SessionManager } from 'utils'
import { toast } from 'react-toastify'
import Aos from 'aos'
import 'aos/dist/aos.css'

const RoleSelection = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const data = useSelector(state => state?.signIn?.data)
    const [isLoading, setIsLoading] = useState(false)

    const DynamicIcon = ({ iconName, size = 60, color = "white" }) => {
        const IconComponent = Icons[iconName];

        if (!IconComponent) {
            // Handle cases where the icon name doesn't exist
            return <User size={size} color={color} />;
        }

        return <IconComponent size={size} color={color} />;
    }

    useEffect(() => {
        Aos.init({ duration: 1000 })
    }, [])

    const handleRoleSelection = (token) => {
        if (isLoading) return;
        setIsLoading(true)
        SessionManager.setCookie("expl_customer_token", `Bearer ${token}`, 3)

        dispatch(sidebar({ navigate })).then((res) => sidebar_res(res.payload))
    };

    const sidebar_res = (res) => {
        if (res?.status === 200) {

            setIsLoading(false)
            const permission = res?.data?.data?.attributes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
            navigate(RoutesMap.DASHBOARD.path)

        } else if (res?.status === 400) {
            setIsLoading(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else {
            setIsLoading(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    const gradients = [
        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        'linear-gradient(135deg, #006972 0%, #b5c3c3 100%)',
        'linear-gradient(135deg, #FFB75E 0%, #ED8F03 100%)',
        'linear-gradient(135deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)',
        'linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)',
        'linear-gradient(135deg, #84fab0 0%, #8fd3f4 100%)',
        'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
        'linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%)',
    ];

    const roleTokensWithGradient = useMemo(() => {
        return data?.role_tokens?.map(role => ({
            ...role,
            bg_gradient: gradients[Math.floor(Math.random() * gradients.length)]
        })) || []
    }, [data?.role_tokens])

    return (
        <div className="role-selection-bg d-flex align-items-center justify-content-center py-5">
            <Container>
                <div className="text-center mb-5" data-aos="fade-down">
                    <h1 className="fw-bold display-5 text-dark mb-2">Who's logging in?</h1>
                    {isLoading && (
                        <h5 className="text-primary mt-3">
                            Please wait, verifying permissions...
                        </h5>
                    )}
                </div>

                <div className="d-flex justify-content-center align-items-center flex-wrap gap-5">
                    {roleTokensWithGradient?.map((role, index) => (
                        <div
                            key={index}
                            className="role-item"
                            onClick={() => handleRoleSelection(role?.access_token)}
                            data-aos="zoom-in"
                            data-aos-delay={index * 100}
                            style={{
                                opacity: isLoading ? 0.7 : 1,
                                pointerEvents: isLoading ? 'none' : 'auto',
                                cursor: isLoading ? 'not-allowed' : 'pointer'
                            }}
                        >
                            <div
                                className="role-avatar"
                                style={{ background: role.bg_gradient }}
                            >
                                <DynamicIcon iconName={role?.role_icon} />
                            </div>
                            <div className="role-name">{role?.role_name}</div>
                        </div>
                    ))}
                </div>
            </Container>
        </div>
    );
};

export default RoleSelection;